import Feature20 from './Feature20'
export default Feature20
